import { useMemo, useCallback } from 'react';
import { CHANGELOG, ChangelogEntry } from '../configs/changelog';

const STORAGE_KEY = 'lastSeenVersion';

export const useWhatsNew = () => {
  const latestVersion = CHANGELOG[0]?.version || '';

  const lastSeenVersion = useMemo(() => {
    return localStorage.getItem(STORAGE_KEY) || '';
  }, []);

  const hasNewUpdates = useMemo(() => {
    if (!latestVersion || !lastSeenVersion) return !!latestVersion;
    return latestVersion !== lastSeenVersion;
  }, [latestVersion, lastSeenVersion]);

  const unseenEntries = useMemo((): ChangelogEntry[] => {
    if (!lastSeenVersion) return CHANGELOG;
    const idx = CHANGELOG.findIndex((e) => e.version === lastSeenVersion);
    if (idx <= 0) return idx === 0 ? [] : CHANGELOG;
    return CHANGELOG.slice(0, idx);
  }, [lastSeenVersion]);

  const markAsSeen = useCallback(() => {
    localStorage.setItem(STORAGE_KEY, latestVersion);
    window.dispatchEvent(new Event('whats-new-seen'));
  }, [latestVersion]);

  return { hasNewUpdates, latestVersion, lastSeenVersion, unseenEntries, markAsSeen };
};
